import classNames from 'classnames'
import { MouseEventHandler, useRef } from 'react'

import type { IHierarchyKeyObjectives } from '../../../../lpKeyInitiatives/components/keyInitiativeEditorModal/models/hierarchyKeyObjectives'

import { useSingleRootExpansion } from './useSingleRootExpansion'

import styles from './KeyObjectives.module.scss'

interface IKeyObjectiveItemProps {
  item: IHierarchyKeyObjectives
  isSelectable: boolean
  expansionKeys: readonly string[]
  onParentClick: MouseEventHandler<HTMLDivElement>
}

export const KeyObjectiveItem = ({
  item,
  isSelectable,
  expansionKeys,
  onParentClick,
}: IKeyObjectiveItemProps) => {
  const rootRef = useRef<HTMLDivElement>(null)
  useSingleRootExpansion(rootRef, expansionKeys)

  return (
    <div
      ref={rootRef}
      className={styles.item}
      onClick={!isSelectable && item.HasChildren ? onParentClick : undefined}
    >
      <div className={styles.label}>
        <span>{item.key}</span>
        {!!item.mdfSync && <span className={styles.badge}>MDF</span>}
      </div>
      {isSelectable && <i className={classNames('kbase kbase-check', styles.icon)} />}
    </div>
  )
}
